import { useState } from 'react';
import { RECENT_VISIBLE_LIMIT } from './constants';

export function useRecentExpansion<T>(items: T[]) {
  const [expanded, setExpanded] = useState(false);
  const hiddenCount = Math.max(0, items.length - RECENT_VISIBLE_LIMIT);
  const visible = expanded ? items : items.slice(0, RECENT_VISIBLE_LIMIT);
  return {
    visible,
    hiddenCount,
    expanded,
    toggle: () => setExpanded((e) => !e),
    canToggle: items.length > RECENT_VISIBLE_LIMIT,
  };
}
